import React, { useState, useEffect } from "react";
import { Breadcrumb, Button, Card, CardBody, CardHeader, Col, Container, Form, Row, Stack } from "react-bootstrap";
 
import { useLocation,useNavigate } from "react-router-dom";

import PubSub from "pubsub-js";
import Select from "react-select";
import jwt_decode from "jwt-decode";

import fuziElevatorsApi from "../../api/fuziElevatorsApi"
import { ROUTES } from "../../constants/webRouting";
import { regExPattern } from "../../utils/regExPattern";
import { validationMessages } from "../../utils/messages";
import { getUserDetails } from "../../utils/helper";
import { handleUppercaseChange } from "../common/UpperCaseMethod";
import * as constants from "../../constants/CONSTANT";
const UserEdit = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // Define initial errors i.e. required field and their message
    const initialErrors = {
        firstname: { message: validationMessages.firstName.required },
        lastname: { message: validationMessages.lastName.required },
        email: { message: validationMessages.email.required },
        phone: { message: validationMessages.phone.required },
        password: { message: validationMessages.password.required },
        userrole: { message: validationMessages.userRole.required },
        managerid: { message: validationMessages.managerId.required },
    };

    const userInfo = getUserDetails();
    // console.log("userInfo", userInfo);
    const initialValues = {
      managerid: userInfo?.id,
      managername: userInfo?.username,
    };
    // user state
    const [user, setUser] = useState(location.state ? location.state : initialValues);

    //errors state
    const [errors, setErrors] = useState(!location.state ? initialErrors : {});

    // managers state
    const [managers, setManagers] = useState([]);
    // const [option, setoption] = useState();
    // const [selectedUser, setSelectedUser] = useState('');
    const [validated, setValidated] = useState(false);
    // const [show, setShow] = React.useState(false);

    useEffect(() => {

        if (user.id) {
            // console.log('if call')
            // let temp = {}
            // temp.value = user.managerid;
            // temp.label = user.managername;
            // setoption(temp);

        } else {
            // let userInfo = jwt_decode(localStorage.getItem('token'));
            // console.log('userInfo', userInfo);
            // let temp = {}
            // temp.value = userInfo.id;
            // temp.label = userInfo.username;
            // setoption(temp);

            setUser((prev) => ({ ...prev, managerid: userInfo.id, managername: userInfo.username }))
        }
        async function init() {
            const result = await fuziElevatorsApi.fetchUsers();

            if (result) {
                let ar = [];
                // var obj = {};

                result.map((item) => {
                    if (item.userrole !== 'USER') {
                        var obj = {};
                        obj.value = item.id;
                        obj.label = item.username;
                        ar.push(obj);
                    }

                });
                setManagers(ar);
            } else {
                setManagers([]);
            }
        }
        init();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        // console.log(e.target);

        if (name == "firstname") {
            if (value == "") {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.firstName.required } }));
            } else if (e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.firstName.invalid } }));
            } else {
                setErrors((prev) => {
                    delete prev[name];
                    return { ...prev };
                });
            }
        }
        else if (name == "lastname") {
            if (value == "") {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.lastName.required } }));
            } else if (e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.lastName.invalid } }));
            } else {
                setErrors((prev) => {
                    delete prev[name];
                    return { ...prev };
                });
            }
        }
        else if (name == "email") {
            if (value == "") {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.email.required } }));
            } else if (e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.email.invalid } }));
            } else {
                setErrors((prev) => {
                    delete prev[name];
                    return { ...prev };
                });
            }
        }
        else if (name === "phone") {
            if (value === "") {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.phone.required } }));
            } else if (e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.phone.invalid } }));
            } else {
                setErrors((prev) => {
                    delete prev[name];
                    return { ...prev };
                });
            }
        }
        else if (name === "password") {
            if (value === "") {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.password.required } }));
            } else if (e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.password.invalid } }));
            } else {
                setErrors((prev) => {
                    delete prev[name];
                    return { ...prev };
                });
            }
        }
        else if (name === "userrole") {
            if (value === "") {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.userRole.required } }));
            } else {
                setErrors((prev) => {
                    delete prev[name];
                    return { ...prev };
                });
            }
        }
        else if (name === "managerid") {
            if (value === "") {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.managerId.required } }));
            } else {
                setErrors((prev) => {
                    delete prev[name];
                    return { ...prev };
                });
            }
        }

        setValidated(true);
        setUser((prev) => ({ ...prev, [name]: value }));
    };

    const checkRequiredFields = () => {
        let isError = false;
        //console.log(selectedUser)
        // if ((user?.firstname && user?.firstname.trim() !== '') && user?.lastname &&
        //     user.email && user.userrole && user.phone) {
        //     return false;
        // }

        if (user?.firstname) {

            if (user?.firstname == "") {
                setErrors((prev) => ({ ...prev, 'firstname': { message: validationMessages.firstName.required } }));
                isError = true;
            } else if (regExPattern?.name && (!RegExp(regExPattern.name).test(user.firstname))) {
                setErrors((prev) => ({ ...prev, 'firstname': { message: validationMessages.firstName.invalid } }));
                isError = true;
            } else {
                setErrors((prev) => {
                    delete prev['firstname'];
                    return { ...prev };
                });
            }

        }

        if (user?.lastname) {

            if (user?.lastname == "") {
                setErrors((prev) => ({ ...prev, 'lastname': { message: validationMessages.lastName.required } }));
                isError = true;
            } else if (regExPattern?.name && (!RegExp(regExPattern.name).test(user.lastname))) {
                setErrors((prev) => ({ ...prev, 'lastname': { message: validationMessages.lastName.invalid } }));
                isError = true;
            } else {
                setErrors((prev) => {
                    delete prev['lastname'];
                    return { ...prev };
                });
            }

        }

        if (user?.email) {
            if (user?.email == "") {
                setErrors((prev) => ({ ...prev, 'email': { message: validationMessages.email.required } }));
                isError = true;
            }
            else if (regExPattern?.email && (!RegExp(regExPattern.email).test(user.email))) {
                setErrors((prev) => ({ ...prev, 'email': { message: validationMessages.email.invalid } }));
                isError = true;

            } else {
                setErrors((prev) => {
                    delete prev['email'];
                    return { ...prev };
                });
            }
        }



        if (user?.phone) {
            if (user?.phone == "") {
                setErrors((prev) => ({ ...prev, 'phone': { message: validationMessages.phone.required } }));
                isError = true;
            } else if (regExPattern?.phone && (!RegExp(regExPattern.phone).test(user.phone))) {
                setErrors((prev) => ({ ...prev, 'phone': { message: validationMessages.phone.invalid } }));
                isError = true;
            } else {
                setErrors((prev) => {
                    delete prev['phone'];
                    return { ...prev };
                });
            }
        }

        if (user?.password) {
            if (user?.password == "") {
                setErrors((prev) => ({ ...prev, 'password': { message: validationMessages.password.required } }));
                isError = true;
            } else if (regExPattern?.password && (!RegExp(regExPattern.password).test(user.password))) {
                setErrors((prev) => ({ ...prev, 'password': { message: validationMessages.password.invalid } }));
                isError = true;
            } else {
                setErrors((prev) => {
                    delete prev['password'];
                    return { ...prev };
                });
            }
        }

        if (user?.userrole) {
            if (user?.userrole == "") {
                setErrors((prev) => ({ ...prev, 'userrole': { message: validationMessages.userRole.required } }));
                isError = true;
            } else {
                setErrors((prev) => {
                    delete prev['userrole'];
                    return { ...prev };
                });
            }
        }

        if (user?.managerid) {
            if (user?.managerid == "") {
                setErrors((prev) => ({ ...prev, 'managerid': { message: validationMessages.managerId.required } }));
                isError = true;
            } else {
                setErrors((prev) => {
                    delete prev['managerid'];
                    return { ...prev };
                });
            }
        }

        // handle errors for required fields
        if (!user?.firstname) {
            setErrors((prev) => ({ ...prev, 'firstname': { message: validationMessages.firstName.required } }));
            isError = true;
        }
        if (!user?.lastname) {
            setErrors((prev) => ({ ...prev, 'lastname': { message: validationMessages.lastName.required } }));
            isError = true;
        }
        if (!user?.email) {
            setErrors((prev) => ({ ...prev, 'email': { message: validationMessages.email.required } }));
            isError = true;
        }
        if (!user?.phone) {
            setErrors((prev) => ({ ...prev, 'phone': { message: validationMessages.phone.required } }));
            isError = true;
        }
        if (!user?.id) {
            if (!user?.password) {
                setErrors((prev) => ({ ...prev, 'password': { message: validationMessages.password.required } }));
                isError = true;
            }
            if (!user?.userrole) {
                setErrors((prev) => ({ ...prev, 'userrole': { message: validationMessages.userRole.required } }));
                isError = true;
            }
        }
        if (!user?.managerid) {
            setErrors((prev) => ({ ...prev, 'managerid': { message: validationMessages.managerId.required } }));
            isError = true;
        }
        console.log('isError', isError);
        return isError;
    }




    const handleSubmit = async (e) => {
        // console.log('handle submit call', user);
        // console.log('handle submit call', e.currentTarget);
        // console.log('handle submit call', e.currentTarget.checkValidity);
        // console.log('handle submit call', e.currentTarget.checkValidity());
        e.preventDefault();

        console.log('user', user);
        console.log('errors', errors);

        if (checkRequiredFields()) {
            setValidated(true);
            return;
        }

        console.log('user', user);
        console.log('errors', errors);

        if (Object?.keys(errors)?.length != 0) {
            setValidated(true);
            return;
        }

        //========= Logic to perform Create or Edit ======
        let result = {};
        if (user?.id) {
            result = await fuziElevatorsApi.saveUser(user);
            if (result?.success) {
                PubSub.publish("RECORD_SAVED_TOAST", {
                    title: "Record Saved",
                    message: "Record saved successfully",
                });
                navigate(`/users/${user?.id}`, { state: user });
            }
            else {
                PubSub.publish("RECORD_ERROR_TOAST", {
                    title: "Record update Error",
                    message: result?.errors,
                });
            }
        } else {
            // console.log('user===>', user);
            result = await fuziElevatorsApi.createUser(user);
            //console.log('result create', result)
            if (result?.success) {
                PubSub.publish("RECORD_SAVED_TOAST", {
                    title: "Record Saved",
                    message: "Record saved successfully",
                });
                navigate(`/users/${result?.id}`, { state: result });
            } else {
                PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record Save Error', message: result?.errors });
            }
        }

    }

    const handleCancel = () => {
        if (user.id) {
            navigate(`/users/${user.id}`, { state: user })

        } else {
            navigate(`/users/`)
        }

    }




    const handleActive = (e) => {
        setUser({ ...user, [e.target.name]: e.target.checked });
    };



    // const handleUsers = (event) => {
    //     //console.log(event)
    //     // setoption(event);
    //     setSelectedUser(event)
    //     setUser({ ...user, managerid: event.value, managername: event.label });
    // }

    return (
        <Container className="view-form">
            <Row >

                <Col lg={12} className="sticky-breadcrumb">
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>Home</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={() => navigate(ROUTES.USER.LIST)} >Users</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
                <Col lg={12}>

                    <Form
                        className=""
                        onSubmit={handleSubmit}
                        noValidate
                        validated={validated}
                    >
                        <Card className="shadow">
                            <CardHeader className="bg-custom text-white sticky-card-header">
                                <Row className="w-100"  >
                                    <Col lg={6} className="" >
                                        <div className="d-flex align-items-center h-100 gap-3" >
                                            <h5 className="m-0">
                                                User
                                            </h5>
                                            <h5 className="m-0">
                                                {`${user.firstname || ""} ${user.lastname || ""}`}
                                            </h5>
                                        </div>
                                    </Col>
                                    <Col lg={6} className="p-0" >
                                        <Stack direction="horizontal" className="float-end" gap={2}>
                                            <Button
                                                size="sm"
                                                className="btn-save"
                                                // onClick={handleSubmit}
                                                type="submit"
                                            >
                                                Save
                                            </Button>

                                            <Button
                                                size="sm"
                                                className="btn-cancel"
                                                onClick={handleCancel}
                                            >
                                                Cancel
                                            </Button>
                                        </Stack>

                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Row className="ibs-edit-form">
                                    {/* <Alert variant="danger" show={show} className="error-alert my-4 ">
                                        Please fill required fields
                                    </Alert> */}
                                    <Row lg={12} className="mb-4">
                                        <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicFirstName"
                                                >
                                                    First Name
                                                </Form.Label>
                                                <Form.Control
                                                    required
                                                    type="text"
                                                    name="firstname"
                                                    placeholder="Enter firstname"
                                                    value={user?.firstname || ""}
                                                    pattern={regExPattern.name}
                                                    onChange={(e) => handleUppercaseChange(e, handleChange)}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.firstname?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicLastName"
                                                >
                                                    Last Name
                                                </Form.Label>
                                                <Form.Control
                                                    //style={{ height: "36px" }}
                                                    required
                                                    type="text"
                                                    name="lastname"
                                                    placeholder="Enter lastname"
                                                    value={user?.lastname || ""}
                                                    pattern={regExPattern.name}
                                                    onChange={(e) => handleUppercaseChange(e, handleChange)}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.lastname?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicEmail"
                                                >
                                                    Email
                                                </Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    required
                                                    name="email"
                                                    placeholder="Enter email"
                                                    value={user?.email || ""}
                                                    pattern={regExPattern.email}
                                                    onChange={handleChange}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.email?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicPhone"
                                                >
                                                    Phone
                                                </Form.Label>
                                                <Form.Control
                                                    required
                                                    type="phone"
                                                    name="phone"
                                                    placeholder="Enter phone"
                                                    value={user?.phone || ""}
                                                    pattern={regExPattern.phone}
                                                    onChange={handleChange}
                                                    maxLength={10}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.phone?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        {!user.id ? <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicpassword"
                                                >
                                                    Password
                                                </Form.Label>
                                                <Form.Control
                                                    required
                                                    type="password"
                                                    name="password"
                                                    placeholder="Enter Password"
                                                    value={user?.password || ""}
                                                    pattern={regExPattern.password}
                                                    onChange={handleChange}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.password?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                        </Col>
                                            : ''}
                                        {!user.id || userInfo.userrole === 'SUPER_ADMIN' ?
                                            <Col lg={6}>
                                                <Form.Group>
                                                    <Form.Label className="form-view-label">TYpe</Form.Label>
                                                    <Form.Select
                                                        name="userrole"
                                                        onChange={handleChange}
                                                        required
                                                        value={user?.userrole || ""}
                                                    >
                                                        <option value="">-- Select --</option>
                                                        {/* <option value="Director">Director</option> */}
                                                        {/* <option value="Accounts">Accounts</option>
                                                        <option value="Installation Supervisor">Installation Supervisor</option>
                                                        <option value="Office">Office</option> */}
                                                        {constants.ROLES.map((role, index) => (
                                                            <option key={index} value={role}>
                                                                {role}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors?.userrole?.message}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            : ''}


                                        <Col >
                                            <Form.Group>
                                                <Form.Label className="form-view-label" htmlFor="formBasicOwner" >
                                                    Manager
                                                </Form.Label>
                                                <Select
                                                    name="managerid"
                                                    placeholder="Select your manager"
                                                    // value={{value:""}}
                                                    className={`${user?.managerid ? 'custom-select-valid' : 'custom-select-invalid'}`}
                                                    onChange={(e) => {
                                                        console.log(e);
                                                        handleChange({ target: { name: "managerid", value: e.value } });
                                                        handleChange({ target: { name: "managername", value: e.label } });
                                                    }}
                                                    options={managers}
                                                    getOptionValue={(option) => option.value}
                                                    value={user?.managerid ? { value: user?.managerid || "", label: user?.managername || "" } : ""}
                                                    
                                                />
                                                
                                                {(errors?.managerid?.message && (!user.managerid) )&& <div className="feedback-invalid"> 
                                                    {errors?.managerid?.message}
                                                </div>}
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicPin"
                                                >
                                                    Active
                                                </Form.Label>

                                                <Form.Check
                                                    inline
                                                    name="isactive"
                                                    type="checkbox"
                                                    value="true"
                                                    checked={user?.isactive === true}
                                                    id="inline-checkbox-9"
                                                    onChange={handleActive}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Row>
                            </CardBody>
                        </Card>
                        {/* <Row className="view-form-header align-items-center">
                            <Col lg={8}>

                                {
                                    user.firstname === undefined ? <h6>Create User</h6> : <h6>Edit User</h6>
                                }
                                <h4></h4>

                            </Col>
                            <Col lg={4} className="d-flex justify-content-end">
                                <Button className="btn-sm mx-2" onClick={handleSubmit}>
                                    Save
                                </Button>
                                <Button
                                    className="btn-sm"
                                    variant="danger"
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </Button>
                            </Col>
                        </Row> */}

                    </Form>
                </Col>
            </Row>

        </Container>


    )
}

export default UserEdit
